import { Skeleton as MUISkeleton, SkeletonProps } from '@mui/material';
import { mergeSX } from '../../services/helpers';

const buildSX = () => ({
  '&.MuiSkeleton-root': {
    transform: 'none',
    width: 'inherit',
    maxWidth: '100%',
  },
});

const Skeleton = (props: SkeletonProps) => {
  const { children, sx, ...restProps } = props;

  return (
    <MUISkeleton
      sx={mergeSX(buildSX(), sx)}
      {...restProps}
    >
      {children}
    </MUISkeleton>
  );
};

export default Skeleton;
